import { BookOpenIcon, CalendarCheckIcon, LayoutGridIcon, SparklesIcon, TagIcon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export type LinkCard = {
  icon: LucideIcon
  title: string
  copy: string
  href: string
}

export const popularPages: LinkCard[] = [
  { icon: LayoutGridIcon, title: 'Products', copy: 'Sales, stock, expenses, reports, and more.', href: '/products/sales-pos' },
  { icon: TagIcon, title: 'Pricing', copy: 'Simple plans in RWF, with no hidden fees.', href: '/pricing' },
  { icon: CalendarCheckIcon, title: 'Book a demo', copy: 'A 30-minute walkthrough for your business.', href: '/demo' },
  { icon: SparklesIcon, title: 'What’s new', copy: 'The latest features and improvements.', href: '/whats-new' },
]

export const whileYouWait: LinkCard[] = [
  { icon: LayoutGridIcon, title: 'Explore products', copy: 'See how sales, stock, and reports work together.', href: '/products/sales-pos' },
  { icon: TagIcon, title: 'Compare plans', copy: 'Find the plan that fits your team and branches.', href: '/pricing' },
  {
    icon: BookOpenIcon,
    title: 'Customer story',
    copy: 'How Mizero Café & Bakery serves 34% more customers a day.',
    href: '/products/sales-pos',
  },
]
